import React from "react";

const GreenMilesPageHeader = () => {
  // return (
  //   <div className="mb-8 mt-8">
  //     <div className="flex justify-between items-center ml-6 mr-6">
  //       <div>
  //         <h1 className="mb-4 text-3xl font-bold text-gray-900">Parc GreenMiles</h1>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default GreenMilesPageHeader;
